/**
 * Which "You're available" notice this device has already shown (one per
 * notice key, P7d). localStorage is a per-device convenience only: in a
 * private window it falls back to this session's memory.
 */
const SEEN_KEY = 'ee.availability-notice.seen';
const seenThisSession = new Set<string>();

export function alreadySeen(key: string): boolean {
  if (seenThisSession.has(key)) return true;
  try {
    return window.localStorage.getItem(SEEN_KEY) === key;
  } catch {
    return false;
  }
}

export function markSeen(key: string): void {
  seenThisSession.add(key);
  try {
    window.localStorage.setItem(SEEN_KEY, key);
  } catch {
    /* private mode: the in-memory set still holds it for this session */
  }
}

/** Test seam: forget what this session has seen. */
export function resetSeenNotices(): void {
  seenThisSession.clear();
}
